function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M24,109 L939,109 C941.209139,109 943,110.790861 943,113 L943,165 C943,167.209139 941.209139,169 939,169 L24,169 C21.790861,169 20,167.209139 20,165 L20,113 C20,110.790861 21.790861,109 24,109 Z",
  id: "path-1"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-1.4%",
  y: "-19.2%",
  width: "102.9%",
  height: "145.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 2,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UI-Modules",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Search-Updates---2",
  transform: "translate(-915.000000, -182.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 1224,
  height: 2473
}), /*#__PURE__*/React.createElement("g", {
  id: "Search-Box",
  transform: "translate(32.000000, 48.000000)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#109889",
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,0 L955,0 C959.418278,-8.11624501e-16 963,3.581722 963,8 L963,182 L963,182 L0,182 L0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-2"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#1ABA9A",
  strokeWidth: 1,
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "dropdown-arrow",
  transform: "translate(883.000000, 134.000000)",
  fill: "#109889"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  points: "18.2377732 0 10 8.22390449 1.76222677 0 -9.04165631e-13 2.01788444 9.99878037 12 10 11.9987002 10.0010841 12 20 2.01788444"
})))));

var SvgChevronDown = function SvgChevronDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-down.f15279df.svg";
export { ForwardRef as ReactComponent };